import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    refresh: false
}

export const leavePolicyReducerSlice = createSlice({
    name: 'leavePolicy',
    initialState,
    reducers: {
        setRefresh: (state, action) => {
            return { ...state, ...action.payload };
        }
    }
})

export const { setRefresh } = leavePolicyReducerSlice.actions;
export default leavePolicyReducerSlice.reducer